"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var styles = {
  "fallback": "fallback_1imkgk",
  "title": "title_3zsvEC"
}; 
require('./DefaultErrorFallback.css');
var DefaultErrorFallback = function DefaultErrorFallback() {
  return /*#__PURE__*/_react.default.createElement("div", {
    role: "status",
    className: styles.fallback
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "error-fallback-title",
    className: styles.title
  }, "Something went wrong"), /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "error-fallback-description",
    className: styles.description
  }, "Try refreshing the page. If the problem persists please", ' ', /*#__PURE__*/_react.default.createElement("a", {
    href: "https://support.mulesoft.com/"
  }, "contact support"), "."));
};
var _default = exports.default = DefaultErrorFallback;
//# sourceMappingURL=DefaultErrorFallback.js.map